/**
 * @module NotificationTypeBadge
 * @package @geenius/notifications-react-css
 * @description Renders a small semantic badge for a notification type in the
 * React vanilla CSS variant.
 */

import type { NotificationType } from '@geenius/notifications/shared'
import { getNotificationTypeLabel, TYPE_CONFIG } from '@geenius/notifications/shared'
import type { JSX } from 'react'
import { cx } from '../lib/cx'
import { useNotificationCopy } from '../lib/notificationCopy'

/**
 * Props for the notification type badge.
 */
export interface NotificationTypeBadgeProps {
  type: NotificationType
  className?: string
}

/**
 * Renders a semantic badge for a notification type.
 *
 * @param props Badge props.
 * @returns The rendered badge.
 */
export function NotificationTypeBadge({
  type,
  className,
}: NotificationTypeBadgeProps): JSX.Element {
  const { t } = useNotificationCopy()
  const config = TYPE_CONFIG[type]

  return (
    <span
      className={cx(
        'notifications__type-badge',
        `notifications__type-badge--${type}`,
        className,
      )}
    >
      {config.icon} {getNotificationTypeLabel(type, t)}
    </span>
  )
}
